import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { DataRecoveryPriorityMode } from '../models';
import { AbstractApiResponse } from '../../shared/models';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class DataRecoveryPriorityModesService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  getDataRecoveryPriorityMode(
    iri: string
  ): Observable<DataRecoveryPriorityMode> {
    return this.rolesService.userHasRoleFilter<DataRecoveryPriorityMode>(
      'ROLE_MWS_DATA_RECOVERY_PRIORITY_MODE_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  getDataRecoveryPriorityModes(): Observable<AbstractApiResponse | any> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_DATA_RECOVERY_PRIORITY_MODE_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(`/data_recovery_priority_modes`)
    );
  }
}
